import {
  Button,
  Modal,
  ModalBody,
  Flex,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Textarea,
} from '@chakra-ui/react';
import ModalHeaderComponent from '../../../../components/ModalHeader';
import { useState } from 'react';
import { serverApi, requestServerApi } from '../../../../api/api';
import { MAX_THEME_CHARS } from '../../../../configs';
import useErrorPage from '../../../../hooks/useErrorPage/useErrorPage';
import useAppToast from '../../../../hooks/useAppToast/useAppToast';

export default function ThemeEditModal({ onCloseModal, lesson, onUpdateSuccess }: any) {
  const [confirming, setConfirming] = useState(false);
  const [theme, setTheme] = useState(lesson?.theme || '');
  const { apiErrorHandler } = useErrorPage();
  const { displayToast } = useAppToast();

  const handleInputChange = (e: any) => {
    setTheme(e.target.value);
  };

  const onUpdateTheme = () => {
    if (theme.length > MAX_THEME_CHARS) {
      displayToast('テーマの更新', `テーマを${MAX_THEME_CHARS}桁以内に設定してください。`, 'error');
      return;
    }
    
    setConfirming(true);
    requestServerApi<any>(() =>
      serverApi
        .organizationsControllerUpdateThemeOnLesson(lesson.company_id, lesson.lesson_id, theme)
        .catch((e) =>
          apiErrorHandler(e, {
            componentName: 'lesson',
            functionName: serverApi.organizationsControllerUpdateThemeOnLesson.name,
          }),
        ),
    ).then((result) => {
      if (onUpdateSuccess) {
        onUpdateSuccess(result);
      } else {
        onCloseModal();
      }
    });
  };

  return (
    <>
      <Modal isOpen={true} onClose={() => onCloseModal()} closeOnOverlayClick={false} isCentered>
        <ModalOverlay />
        <ModalContent minW="55rem">
          <ModalHeaderComponent title={'テーマ編集'} />
          <ModalBody>
            <label>テーマ</label>
            <Flex justifyContent="right" mb={2}></Flex>
            <Textarea
              placeholder="テーマが入力されていません"
              rows={3}
              onChange={handleInputChange}
              value={theme}
            />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="teal" mr={3} disabled={confirming} onClick={() => onUpdateTheme()}>
              {'更新'}
            </Button>
            <Button colorScheme="gray" mr={3} disabled={confirming} onClick={() => onCloseModal()}>
              {'キャンセル'}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
